import { GroupWork } from "@mui/icons-material";
import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import farmSo from "stores/farm";
import SelectorDialogBase from "../base/SelectorDialogBase";
import Chip from "./Chip";



interface Props {
	scope?: string,
	group?: string
	onChange: (scope: string) => void,
	sx?: any
}

const SelectorScopeGroupH: FunctionComponent<Props> = ({
	scope,
	group,
	onChange,
	sx,
}) => {


	// STORE

	// HOOKs
	const { t } = useTranslation()
	const [isOpen, setIsOpen] = useState(false)

	// HANDLER
	const handleClick = () => {
		setIsOpen(true)
	}
	const handleClose = (group: string) => {
		setIsOpen(false)
		if (group) onChange?.(group.toLowerCase())
	}
	const handleClear = (e: React.MouseEvent) => {
		e.stopPropagation()
		setIsOpen(false)
		onChange?.(null)
	}

	// RENDER
	const groups = farmSo.state.scopes?.[scope]?.map(s => s?.toUpperCase()) ?? []
	const disabled = !scope || groups.length === 0
	const active = !!group
	const label = !scope ? "SELECT A SCOPE"
		: groups.length === 0 ? "NO GROUP"
		: (group?.toUpperCase() ?? "ALL GROUPS")
	
	return (<>
		<Chip sx={sx}
			disabled={disabled}
			label={label}
			icon={<GroupWork sx={{ width: 16, height: 16}} />}
			active={active}
			onClick={handleClick}
			onClear={handleClear}
		/>
		<SelectorDialogBase
			width={"auto"}
			height={null}
			items={groups}
			idSelect={group}
			title={t("selector.scope.title")}
			isOpen={isOpen}
			onClose={handleClose}
		/>
	</>)
}

export default SelectorScopeGroupH
